/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import {
  State, CurrentState, SelectingState, Item,
} from '../menu-list.slice';
import { hasSelectedAll } from './helpers';

export default function toggleItem(state: State, action: PayloadAction<Item>): void {
  if (state.current !== CurrentState.selecting) return;

  const itemIndex = state.selected.findIndex((r) => r.id === action.payload.id);
  if (itemIndex !== -1) {
    state.selected.splice(itemIndex, 1);
  } else {
    state.selected.push(action.payload);
  }
  state.selectingState = hasSelectedAll(state)
    ? SelectingState.allAvailable
    : SelectingState.simple;
}
